module.exports = __webpack_public_path__ + "static/sky-run_grzegorz-sudol_en-265910bc9b0b1df20f8b465ce8f2c0e0.jpg";